import { bool, func, object } from 'prop-types';
import React from 'react';
import { Button } from 'reactstrap';

import getInfoTooltip from '../../generic/Tooltip/get-info-tooltip';
import api from '../../REST/api';
import withApiRequest from '../../REST/with-api-request';
import HELP_TEXTS from '../help-texts';

function ExportAllCampaigns({
  onRequest,
  loading,
  searchParams,
  tableFilters,
  ...rest
}) {
  return (
    <Button
      disabled={loading}
      onClick={() =>
        onRequest({ search: { ...searchParams, ...tableFilters } })
      }
      {...rest}
    >
      Export{' '}
      {getInfoTooltip(HELP_TEXTS, 'exportCampaigns', 'actionButtons', 'top')}
    </Button>
  );
}

ExportAllCampaigns.propTypes = {
  onRequest: func.isRequired,
  loading: bool.isRequired,
  searchParams: object, // eslint-disable-line react/forbid-prop-types,
  tableFilters: object, // eslint-disable-line react/forbid-prop-types,
};

ExportAllCampaigns.defaultProps = {
  searchParams: undefined,
  tableFilters: undefined,
};

export default withApiRequest({
  query: api.exportCampaigns,
  error: 'flash',
  successMessage: 'Email with all campaigns is being prepared',
})(ExportAllCampaigns);
